/**
 * REGISTRO DOS AVISOS DE MUDANÇA — "isto mudou de lugar / novidade".
 *
 * Aviso novo = UMA entrada aqui + os textos em `guidedTour.avisos.<id>` nos
 * locales. O anfitrião (`AvisoDeMudancaHost`) não muda. O `id` é a chave do que
 * o usuário já fechou: nunca reaproveite um id de aviso antigo.
 */
import { abrirGavetaNoCelular } from './passos'

export interface AvisoDeMudanca {
  id: string
  /** Seletor CSS da parte da tela que mudou. */
  alvo: string
  lado: 'top' | 'bottom' | 'left' | 'right'
  /** Roda antes de esperar o alvo (ex.: abrir a gaveta da barra lateral no celular). */
  prepara?: () => void
}

export const AVISOS: readonly AvisoDeMudanca[] = [
  {
    id: 'ajuda-e-tour',
    alvo: '[data-testid="sidebar-help-btn"]',
    lado: 'right',
    prepara: abrirGavetaNoCelular,
  },
]

/** Chaves i18n do aviso (título e texto), sempre sob `guidedTour.avisos.<id>`. */
export function chavesDoAviso(id: string): { titulo: string; texto: string } {
  return { titulo: `guidedTour.avisos.${id}.titulo`, texto: `guidedTour.avisos.${id}.texto` }
}

/** O primeiro aviso que este usuário ainda não fechou. */
export function proximoAviso(
  vistos: readonly string[],
  registro: readonly AvisoDeMudanca[] = AVISOS,
): AvisoDeMudanca | null {
  return registro.find((a) => !vistos.includes(a.id)) ?? null
}
